import dateService from '@gem/services/date-service';

import Tasks from 'APP/Tasks';
import bus from 'APP/packages/bus';
import { broadcastSentMessage } from 'APP/packages/bus/adapters/messaging/sentMessage';
import Entities from 'STORE';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';
import { MessageError } from 'STORE/Messages/Message/ChatMessage/ChatMessages.types';
import { Payload } from 'STORE/Messages/Message/Payload/Payload';
import { Quote } from 'STORE/Messages/Message/Quote/Quote';

import { clearInputPanel } from './clearInputPanel';
import { createFakeMessage } from './createFakeMessage';
import { sendNewMessageInQueue } from './sendNewMessageInQueue';

interface IMessageData {
  payload: Payload;
  clientUuid?: string;
  repliedMessage?: ChatMessage;
  quote?: Quote;
}

export async function createNewMessages(
  groupId: string,
  messagesData: IMessageData[]
): Promise<void> {
  const hasInvalidQuote = messagesData.some(({ quote }) => quote?.isTextStillValid === false);

  if (hasInvalidQuote) {
    Tasks.messaging.handleInvalidQuote({ groupId });
    return;
  }

  const clientTime = dateService.now().getTime();
  const messages: ChatMessage[] = [];

  messagesData.forEach((data, index) => {
    const message = createFakeMessage({
      groupId,
      payload: data.payload,
      clientUuid: data.clientUuid,
      clientTime: clientTime + index,
      repliedMessage: data.repliedMessage,
      quote: data.quote,
    });

    if (message) {
      messages.push(message);
    }
  });

  if (messagesData.length === 0) {
    return;
  }

  bus.messaging.broadcastSendMessage();

  if (groupId === Entities.GroupsStore.activeGroupId) {
    await Tasks.messaging.addMyFakeNewMessages(groupId, messages);
    clearInputPanel(groupId, messages);
  }

  messages.forEach(async (fakeMessage) => {
    await Tasks.messaging.uploadMessage(fakeMessage);

    if (!fakeMessage.hasError) {
      sendNewMessageInQueue({
        message: fakeMessage,
        errorCallback: (error) =>
          Tasks.messaging.handleMessageError({
            error,
            message: fakeMessage,
            messageErrorType: MessageError.Send,
          }),
      });
    } else {
      broadcastSentMessage(groupId, {
        messageUuid: fakeMessage.clientUuid,
        messageId: fakeMessage.id,
        isRequestFinished: false,
        hasError: true,
      });
    }
  });
}
